import React, { ReactElement } from 'react';
import AddLiquidityLayout from '@app/layouts/AddLiquidityLayout/AddLiquidityLayout';
import { AddLiquidity } from '@app/screens/liquidity/AddLiquidity';
import { NextPageWithLayout } from '@app/pages/_app';

export const LiquidityPageV2: NextPageWithLayout = () => {
  return <AddLiquidity />;
};

LiquidityPageV2.getLayout = function getLayout(page: ReactElement) {
  return <AddLiquidityLayout>{page}</AddLiquidityLayout>;
};

export default LiquidityPageV2;
